import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { useFlags } from '@/context/feature-flags';
import PropertyHeader from '../../components/property-header';
import { Routes } from './components/routes';
import { Tabs } from './components/tabs';

export const AdminDashboard = () => {
  const location = useLocation();
  const { flags } = useFlags();

  const isManager = flags?.['admin-menu'];

  if (!isManager) {
    return null;
  }

  return (
    <section className='py-0 bg-gray-100'>
      <div className='px-0 mx-auto'>
        <div className='bg-white rounded'>
          <div className='pb-2 px-4'>
            <div className='mb-1'>
              <PropertyHeader page={location.pathname} />
            </div>
            <div className='my-2'>
              <Tabs />
            </div>
            <div>
              <Routes />
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip />
    </section>
  );
};
